import type {
  SortDirection,
  SortItem,
} from "@/components/UI/TableToolbar/Sorting/types";

export const getSortStateLabel = (
  sortItem: SortItem | undefined,
  sortIndex: number,
): string | undefined => {
  if (!sortItem) return undefined;

  const direction =
    sortItem.direction === "ascending" ? "ascending" : "descending";

  return `${direction}, priority ${sortIndex + 1}`;
};

export const getSortingWithDirection = (
  sorting: SortItem[],
  field: string,
  direction: SortDirection,
): SortItem[] => {
  const currentIndex = sorting.findIndex((item) => item.field === field);

  if (currentIndex === -1) return [...sorting, { field, direction }];

  return sorting.map((item, index) =>
    index === currentIndex ? { ...item, direction } : item,
  );
};

export const getNextSortingForColumn = (
  sorting: SortItem[],
  field: string,
): SortItem[] => {
  const currentIndex = sorting.findIndex((item) => item.field === field);
  const currentItem = currentIndex === -1 ? undefined : sorting[currentIndex];

  if (!currentItem) return getSortingWithDirection(sorting, field, "ascending");

  if (currentItem.direction === "ascending") {
    return getSortingWithDirection(sorting, field, "descending");
  }

  return sorting.filter((item) => item.field !== field);
};
